import React from 'react';
import Style from './index.module.scss';
import {Schema} from 'form-render/lib/type';
import FormRender, {useForm} from 'form-render';
import {Button, message, Skeleton, Spin} from 'antd';
import useRequestFn from '../../../../../../Utils/Hooks/useRequestFn';
import {getTenant, SaveTenant, saveTenant, TenantType} from '../../../service';
import {errorMessage} from '../../../../../../Utils/common';
import {FlexBox} from '../../../../../../Components/FlexBox';
import useRequest from 'Utils/Hooks/useRequest';
import CustomAntdRules from '../../../../../../Utils/rulesAntd';
import {useNavigate} from 'react-router-dom';
import {isEmpty} from '../../../../../../Stores/commonStore';

interface Props {
    id: string;
    current: number;
    setCurrent: (v: number) => void;
}
const Index = ({id, current, setCurrent}: Props) => {
    const navigator = useNavigate();
    const form = useForm();

    const schema: Schema = {
        type: 'object',
        displayType: 'row',
        labelCol: 8,
        fieldCol: 11,
        properties: {
            serviceSubject: {
                title: '服务主体',
                required: true,
                type: 'string',
            },
            name: {
                title: '服务名称',
                required: true,
                type: 'string',
                extra: '此名称为校友服务的名称，保存后不可修改',
            },
            code: {
                title: '主体域名',
                required: true,
                type: 'string',
                disabled: !isEmpty(id),
                extra: `<div>
                             ·域名至少输入5个半角字符，且只允许4-20位字母[a-z]或数字[0-9]<br>
                             ·自定义域名一旦确认设置便不能修改 <br>
                             ·使用自有域名，需先联系我方技术支持人员完成域名的相关设置才能正常使用。<br>
                             ·自有域名需在万网进行购买且要在阿里云完成域名资质备案。
                        </div>`,
                props: {
                    suffix: process.env['REACT_APP_TENANT_DOMAIN'],
                },
            },
            contacts: {
                title: '联系人',
                type: 'string',
                rules: [{required: true}],
            },
            phone: {
                title: '联系电话',
                type: 'string',
                rules: [CustomAntdRules.MobilePhone, {required: true}],
            },
            email: {
                title: '邮箱地址',
                type: 'string',
                format: 'email',
            },
            locationDetail: {
                title: '详细地址',
                type: 'string',
                widget: 'textArea',
            },
        },
    };

    const [save, {loading: saveLoading}] = useRequestFn(saveTenant);
    async function onFinish(formData: SaveTenant) {
        try {
            const params = formData;
            params.type = TenantType.SaaS;
            if (id) {
                params.id = id;
            }
            const returnId = await save(params);
            if (!id) {
                navigator(returnId, {replace: true});
            }
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    const [defaultData, {loading: getLoading}] = useRequest(
        () => {
            if (id) {
                return getTenant(id);
            } else {
                return Promise.resolve(undefined);
            }
        },
        {},
        [id],
    );

    async function addStep(step: number) {
        const isEdit = form.isFieldsTouched(
            Object.keys(form.getSchema().properties),
        );
        if (isEdit) {
            form.validateFields().then(async res => {
                await onFinish(res);
                message.success('保存成功');
                setCurrent(current + step);
            });
        } else {
            if (id) {
                setCurrent(current + step);
            } else {
                message.info('请先输入内容');
            }
        }
    }

    return (
        <div className={Style.root}>
            <Skeleton active loading={getLoading} paragraph={{rows: 10}}>
                <Spin spinning={saveLoading}>
                    <FormRender
                        initialValues={defaultData}
                        form={form}
                        schema={schema}
                    />
                    <FlexBox justifyContent="center" gap="15px">
                        <Button onClick={() => addStep(1)} type="primary">
                            下一步
                        </Button>
                        {id && (
                            <Button onClick={() => addStep(0)} type="primary">
                                保存
                            </Button>
                        )}
                    </FlexBox>
                </Spin>
            </Skeleton>
        </div>
    );
};

export default Index;
